const color = [
  "#836FFF",
  "#71C671",
  "#BCD2EE",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#A2B5CD",
  "#FFC125",
  "#757575",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC125",
  "#757575"
];
export default color